module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_2_m2.ac4675b963d82f6f32d21c86ae6c0ae1.png";